import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';
import { FaCamera } from 'react-icons/fa';

export const ChannelConfigurationInfoComponent = ({ changeImage, onInnerFormChange, selectedChannels }: any) => (
          <>
          <AccordionContainer
              child={
<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
          label="Color"
          labelField="Color"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Primary.Color',
              selectedChannels?.Configurations?.ChannelBranding?.Primary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Primary?.Color}
      />
   
      <InputContainer
          label="BackgroundColor"
          labelField="BackgroundColor"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Primary.BackgroundColor',
              selectedChannels?.Configurations?.ChannelBranding?.Primary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Primary?.BackgroundColor}
      />
  <InputContainer
          label="BackgroundImage"
          labelField="BackgroundImage"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Primary.BackgroundImage',
              selectedChannels?.Configurations?.ChannelBranding?.Primary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Primary?.BackgroundImage}
      />
   </div>

}
              expandedPanel="Primary Info"
              headerTitle="Primary Info"
          />

     <AccordionContainer
         child={
<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
          label="Color"
          labelField="Color"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Secondary.Color',
              selectedChannels?.Configurations?.ChannelBranding?.Secondary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Secondary?.Color}
      />
   <InputContainer
          label="BackgroundColor"
          labelField="BackgroundColor"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Secondary.BackgroundColor',
              selectedChannels?.Configurations?.ChannelBranding?.Secondary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Secondary?.BackgroundColor}
      />
  <InputContainer
          label="BackgroundImage"
          labelField="BackgroundImage"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Secondary.BackgroundImage',
              selectedChannels?.Configurations?.ChannelBranding?.Secondary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Secondary?.BackgroundImage}
      />
    </div>
}
         expandedPanel="Secondary Info"
         headerTitle="Secondary Info"
     />
      <AccordionContainer
          child={
<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
          label="Color"
          labelField="Color"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Tertiary.Color',
              selectedChannels?.Configurations?.ChannelBranding?.Tertiary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Tertiary?.Color}
      />
  <InputContainer
          label="BackgroundColor"
          labelField="BackgroundColor"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Tertiary.BackgroundColor',
              selectedChannels?.Configurations?.ChannelBranding?.Tertiary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Tertiary?.BackgroundColor}
      />
    <InputContainer
          label="BackgroundImage"
          labelField="BackgroundImage"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Tertiary.BackgroundImage',
              selectedChannels?.Configurations?.ChannelBranding?.Tertiary
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Tertiary?.BackgroundImage}
      />
   </div>

}
          expandedPanel="Tertiary Info"
          headerTitle="Tertiary Info"
      />
       <AccordionContainer
           child={
<div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
          label="Color"
          labelField="Color"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Ghost.Color',
              selectedChannels?.Configurations?.ChannelBranding?.Ghost
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Ghost?.Color}
      />
    <InputContainer
          label="BackgroundColor"
          labelField="BackgroundColor"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Ghost.BackgroundColor',
              selectedChannels?.Configurations?.ChannelBranding?.Ghost
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Ghost?.BackgroundColor}
      />
    <InputContainer
          label="BackgroundImage"
          labelField="BackgroundImage"
          onValueChange={(event: any, newValue: any) => {
            onInnerFormChange(
              event.target.value,
              'Configurations.ChannelBranding.Ghost.BackgroundImage',
              selectedChannels?.Configurations?.ChannelBranding?.Ghost
            );
          }}
          type="text"
          value={selectedChannels?.Configurations?.ChannelBranding?.Ghost?.BackgroundImage}
      />
   </div>  
}
           expandedPanel="Ghost Info"
           headerTitle="Ghost Info"
       />
<AccordionContainer
    child={
    <div onClick={() => changeImage('image')}>
        <InputLabelContainer label="Logo Picture"/>
          <img

              src={selectedChannels?.Configurations?.ChannelLogo}
              className="w-12 h-12"
          />
       <FaCamera  className=' text-2xl text-skin-ouprimary'/>
</div>
     
      }
    expandedPanel="Logo"
    headerTitle="Logo"
/>
</>
)
